import styled from 'styled-components';
import { SliderThumbMixin } from '../../mixins/components/SliderMixin';

/**
 * @since 6.12.0
 */
var SliderThumb = /*#__PURE__*/styled.div.withConfig({
  displayName: "SliderThumb",
  componentId: "c11n-8-111-1__sc-1bk0m5x-0"
})(["", ""], SliderThumbMixin);
SliderThumb.displayName = 'SliderThumb';

/** @component */
export { SliderThumb };